import React, { Component } from "react";
import OwLabel from "../../../shared/OwLabel/OwLabel";
import EndpointsEnum from "../../../../models/EndpointsEnum";
import IQBDSyncVendorUpdateDTO from "../../../../models/DTO/IQBDSyncVendorUpdateDTO";
import IQBDSyncVendorStartDTO from "../../../../models/DTO/IQBDSyncVendorStartDTO";
import { Socket } from "socket.io-client";

type Props = {
    socket: Socket;
};

type State = {
    totalItems: number;
    totalProcessed: number;
    lineWidth: number;
};

class QBDVendorsSyncStatus extends Component<Props, State> {
    readonly state: State = {
        totalItems: 0,
        totalProcessed: 0,
        lineWidth: 0,
    };

    componentDidMount() {
        this.props.socket.on(EndpointsEnum.QBDSyncVendorStart, this.qbdSyncVendorStart);
        this.props.socket.on(EndpointsEnum.QBDSyncVendorUpdate, this.qbdSyncVendorUpdate);
    }

    componentWillUnmount() {
        this.props.socket.removeListener(EndpointsEnum.QBDSyncVendorStart, this.qbdSyncVendorStart);
        this.props.socket.removeListener(EndpointsEnum.QBDSyncVendorUpdate, this.qbdSyncVendorUpdate);
    }

    qbdSyncVendorStart = (data: IQBDSyncVendorStartDTO) => {
        this.setState({
            totalItems: data.totalToProcess,
            lineWidth: 0,
        });
    };

    qbdSyncVendorUpdate = (data: IQBDSyncVendorUpdateDTO) => {
        const lineWidth = (data.totalProcessed / this.state.totalItems) * 100;

        this.setState({
            totalProcessed: data.totalProcessed,
            lineWidth: parseInt(lineWidth.toFixed(0)),
        });
    };

    render() {
        return (
            <div className="QBDItemsSyncStatus">
                <OwLabel title={"processing"} noBottomMargin={true} postText={":"} className={"me-3"} />
                {this.state.totalProcessed} <OwLabel title={"of"} noBottomMargin={true} /> {this.state.totalItems}
                <div className={"bg-warning"} style={{ height: "3px", width: `${this.state.lineWidth}%` }}></div>
            </div>
        );
    }
}

export default QBDVendorsSyncStatus;
